import type { UserProfile } from '@/lib/types'

/**
 * The sample student. Its own tiny module so the auth context (in the entry bundle) can enter a demo session without
 * pulling in `demo-data.ts`, which carries the sample tests, essays and feedback and loads only with the pages that show them.
 */
export const demoProfile: UserProfile & { target?: string } = {
  id: 'demo-student',
  first_name: 'Noura',
  last_name: 'Al-Khatib',
  full_name: 'Noura Al-Khatib',
  email: 'noura@example.com',
  /** The sample student's target band, so the readiness view can show the target line and the gap. */
  target: '6.5',
  user: {
    id: 'demo-user',
    email: 'noura@example.com',
    role: 'student',
  },
}

/**
 * The sample school viewer for the school demo (DECISIONS 16). It is a demo-only role: no backend school role exists, and
 * `enterSchoolDemo` is a no-op error unless `VITE_ENABLE_DEMO_SESSION` is `true`.
 */
export const schoolDemoProfile: UserProfile = {
  id: 'demo-school',
  first_name: 'Sample',
  last_name: 'School',
  full_name: 'Sample School',
  email: 'school@example.com',
  user: {
    id: 'demo-school-user',
    email: 'school@example.com',
    role: 'school_demo',
  },
}
